<template>
  <div class="terms has-background-white-bis fixspace">
    <section class="hero is-medium">
      <div class="hero-body pb-5">
        <div class="container is-max-desktop pb-6">
          <div class="columns">
            <div class="column is-four-fifths is-offset-1">
              <h1 class="title is-4">
                {{ $t('terms.terms') }}
              </h1>
              <p class="is-size-7 py-6 termstext-h">
                This Terms of Service (the “Terms”) describes the rights and responsibilities
                that apply to your use of Musian’s websites, services, and mobile app (collectively,
                the “Service”), each owned and operated by Musian. (“Musian”, “we”, “our” or “us”).
              </p>
              <p class="is-size-7 termstext-h">
                Please read the Terms carefully before using the Service. If you don’t agree to the
                Terms,as well as Musian’s Privacy Policy (the “Privacy Policy”) and Musian’s
                Community Guidelines (the “Community Guidelines”), you may not use the Service.
                If you are entering into the Terms on behalf of a company or other legal entity,
                you represent that you have the authority to bind such entity to the Terms.
                If you do not have such authority, you must not accept the Terms or use the
                Service on behalf of such entity. The Service is only available to you if you
                have entered the age of majority in your jurisdiction of residence and are fully
                able and competent to enter into, abide by and comply with the Terms.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Respect Intellectual Property Rights
            </p>
            <ol type="1" class="pl-5 is-size-7 termstext-h">
              <li class="py-2">Don't present other people's work as your own or overstate
                your own role in creating something. Don't use other people's trademarks
                without permission. If you aren't sure whether your use of someone
                else's content or trademark in your own work is legal, you can consult
                publicly available reference materials at the U.S. Copyright Office website,
                the U.S. Patent & Trademark Office website, the Lumen Project website, or
                talk to an intellectual property attorney. If you want to report misuse of
                your own creative work or your own trademark by one of our users, you can
                do that here.</li>
              <li class="py-2">If you have a contract, employment, or other dispute with
                a Musian user about content or job postings they have uploaded to our
                site, please click the "message" button on that user's profile and
                resolve the issue with the user directly. We can't moderate contract,
                employment, or other disputes between our users and other third-parties.</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Respect Privacy
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Don't use Musian to reveal private information about other people.
              And don't upload photographic portraits or nude images of identifiable
              people unless you have their permission.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Be Authentic
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Musian is a platform for creative professionals to interact genuinely
              with one another. To maintain the quality of these interactions,
              we disable accounts that engage in behavior that undermines the
              authenticity of our community, including but not limited to, the
              following deceptive, harmful behaviors:
            </p>
            <ol type="1" class="pl-5 is-size-7 termstext-h">
              <li class="py-1">Using fake profiles</li>
              <li class="py-1">Impersonating other people or entities</li>
              <li class="py-1">Falsely attributing someone else's work</li>
              <li class="py-1">Using automated or scripted processes (such as bulk
                or automated following or appreciating user accounts, scripted
                commenting on projects, etc.)</li>
              <li class="py-1">Engaging in appreciation schemes or in
                third-party services that claim to boost appreciations</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Your Musian Account
            </p>
            <p class="is-size-7 py-2 termstext-h">
              If you create an account on the Service (your “Account”), you are
              responsible for maintaining the security of your Account and its Content
              (as defined below), and you are fully responsible for all activities that
              occur under your Account and any other actions taken on the Service. You
              must not describe or assign Content to your Account in a misleading or
              unlawful manner, including in a manner intended to trade on the name or
              reputation of others, and Musian may change or remove any description or
              keyword that it considers inappropriate or unlawful, or otherwise likely to
              cause Musian liability. You must immediately notify Musian of any
              unauthorized uses of your Account or any other breaches of security. Musian
              will not be liable for any acts or omissions by you, including any damages
              of any kind incurred as a result of such acts or omissions.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Rules
            </p>
            <ol type="1" class="pl-5 is-size-7 termstext-h">
              <li class="py-1">Use, support or develop bots, scrapers, software, scripts, crawlers,
                browser plugins, robots or other automated methods including human-powered
                automation through like farming or any other crowd-sourced methods to access,
                scrape, or copy the Services, or to add or download data, or send or redirect
                information or messages;</li>
              <li class="py-1">Reverse engineer, decompile, disassemble, decipher or otherwise
                attempt to derive the source code for the Services or any related technology that
                we have not made open source;</li>
              <li class="py-1">Rent, lease, loan, trade, sell or otherwise monetize the Services or
                related data or access to the same, without our express written consent;</li>
              <li class="py-1">Monitor the Services’ availability, performance or functionality
                for any competitive purpose;</li>
              <li class="py-1">Engage in “framing,” “mirroring,” or otherwise simulating
                the appearance or function of the Services;</li>
              <li class="py-1">Post anything that contains software viruses, worms, or any other
                harmful code;</li>
              <li class="py-1">Overlay or otherwise modify the Services or their appearance
                (such as by inserting elements into the Services or removing, covering, or
                obscuring an advertisement included on the Services);</li>
              <li class="py-1">Interfere with the operation of, or place an unreasonable load
                on, the Services (e.g., spam, denial of service attack, viruses, gaming
                algorithms); </li>
              <li class="py-1">Override any security feature or bypass or circumvent any
                access controls or limits of the Services;</li>
              <li class="py-1">Create a false identity, misrepresent your identity, create a
                profile for anyone other than yourself, or use or attempt to use another’s
                account; or</li>
              <li class="py-1">Violate our intellectual property rights or the intellectual
                property rights of others.</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Third Party Websites and Content
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We have not reviewed, and cannot review, all of the material, including computer
              software, made available through the websites and webpages to which Musian
              links, and that link to Musian. Musian does not have any control over those
              non-Musian websites and webpages, and is not responsible for their contents or
              their use. By linking to a non-Musian website or webpage, Musian does not
              represent or imply that it endorses such website or webpage. You are responsible
              for taking precautions as necessary to protect yourself and your computer systems
              from viruses and other harmful or destructive content. Musian disclaims any
              responsibility for any harm resulting from your use of non-Musian websites
              and webpages.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Intellectual Property
            </p>
            <p class="is-size-7 py-2 termstext-h">
              All material available on the Service and all material and services provided by or
              through Musian, its affiliates, subsidiaries, employees, agents, licensors or
              other commercial partners including, but not limited to, software, all
              informational text, software documentation, design of and “look and feel”,
              layout, photographs, graphics, audio, video, messages, interactive and instant
              messaging, design and functions, files, documents, images, or other materials,
              whether publicly posted or privately transmitted as well as all derivative works
              thereof (collectively, the “Materials”), are owned by us or our licensors or
              service providers, and are protected by copyright, trademark, trade secret and
              other intellectual property laws.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              If Musian, in its sole discretion and without notice, considers that there
              is an immediate security or operational risk to the Service, any of its,
              your or a third party system, then Musian may immediately suspend access to
              or use of the Service. The suspension of use and access is not a breach of the
              Terms. You acknowledge that the preservation of security, confidentiality and
              data is paramount. Musian has no liability to you for suspending the Service
              under this provision.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              This section does not apply to Content; however you agree that any ideas,
              suggestions, concepts, processes or techniques which you provide to Musian
              related to the Service or Musian or its business (“Feedback”) are and will
              be Musian’s exclusive property without any compensation or other consideration
              payable to you by Musian, and you do so of your own free will and volition.
              Musian may or may not, in its sole discretion, use or incorporate the Feedback
              in whatever form or derivative Musian may decide into the Service or its
              business or other products. You hereby assign all rights on a worldwide basis
              in perpetuity to Musian in any Feedback and, as applicable, waive any moral
              rights.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              For the purposes of the Terms and the Privacy Policy, “personal information”
              is any information about an identifiable individual, as defined in our
              Privacy Policy.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Musian retains the right to use or share any Aggregated Data generated by
              anyone using the Service, including our users, for the purpose of enhancing
              and providing the Service. “Aggregated Data” means data does not contain
              personal information and which has been manipulated or combined to provide
              generalized, anonymous information. Where you choose to utilize or connect
              certain services from third parties with the Service, you agree that
              Musian may share your lead data with such designated third parties. You
              are still responsible for any and all personal information that is part
              of any Content.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Changes
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Musian reserves the right, at its sole discretion, to modify or replace
              any part of the Terms. It is your responsibility to check the Terms
              periodically for changes. Your continued use of or access to the Service following
              the posting of any changes to the Terms constitutes acceptance of those changes.
              Musian may also, in the future, offer new services and/or features through the
              Service (including, the release of new tools and resources). Such new features
              and/or services shall be subject to the Terms.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Termination
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Musian may terminate your access to all or any part of the Service at any time,
              with or without cause, with or without notice, effective immediately. If you wish
              to terminate the Terms or your Account (if you have one), you may simply
              discontinue using the Service. All provisions of the Terms which by their nature
              should survive termination shall survive termination, including, without
              limitation, ownership provisions, warranty disclaimers, indemnity and limitations
              of liability.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Disclaimer of Warranties
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Your use of the Service and all Content forming part of or related to the Service,
              including any Content you upload or submit and any third party software and
              Content, are at your sole responsibility and risk. The Service are provided on
              an “as is” and “as available” basis. Musian expressly disclaims all
              representations, warranties, or conditions of any kind with respect to the
              Service, whether express or implied, including, but not limited to, any implied
              warranties or conditions of merchantability, fitness for a particular purpose,
              accuracy, completeness, performance, system integration, quiet enjoyment, title,
              and non-infringement.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              The service is offered and controlled by Musian from its facilities in Canada.
              Musian makes no representations that the service is appropriate or available
              for use in locations other than Canada and the United States. Those who access
              or use the Service from other jurisdictions do so at their own volition and are
              responsible for compliance with local law. We handle complaints of copyright
              infringement in accordance with our Copyright Policy.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Contacting Musian
            </p>
            <p class="is-size-7 py-2 termstext-h">
              You may contact Musian please submit ticket at Help Center
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr>
            <p class="is-size-7 has-text-weight-semibold">Updated Febuary 17, 2020</p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

export default {
  name: 'Terms',

  metaInfo() {
    return {
      title: this.$t('title.terms'),
      meta: [
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.terms') },
      ],
    };
  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.terms'));
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.termstext-h {
   line-height: 25px;
}
</style>
